import { useMutation } from 'react-query';
import { request } from '@/utils';

export const useUpdateBannerUrl = () => {
  const mutation = useMutation(
    ({ url, thumbnail_url, id }: { url: string; thumbnail_url: string; id?: string }) => {
      const params = {
        url,
        thumbnail_url,
        id, // set banner for other user (web3 id gifted)
      };

      if (!url) {
        return request.post<{ is_success: boolean }>('/user/delete_banner', {
          id, // set banner for other user (web3 id gifted)
        });
      }

      return request.post<{ is_success: boolean }>('/user/update_banner', params);
    },
  );

  return mutation;
};
